import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';

import { Observable } from 'rxjs/Observable';

import { OAuthService } from 'app/services';

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(private readonly router: Router, private readonly oauthService: OAuthService) {}

  canActivate(): Observable<boolean> {
    return Observable.of(this.oauthService.isLoggedIn())
      .map(loggedIn => {
        if (!loggedIn) {
          this.router.navigate(['/login']);
        }
        return loggedIn;
      })
      .catch(() => {
        this.router.navigate(['/']);
        return Observable.of(false);
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/guards/auth.guard.ts